import { QueryOptions } from './query-options.model';

export class ModuleQueryOptions extends QueryOptions {
    text?: string;
    category?: string;
    compliance?: string;
    scope?: string;
    isOpenSource?: boolean;
    producer_id?: string;
}
